import type { CSSProperties, FunctionComponent } from 'react';
import type { IEventTimelineItem } from './timelineLayout';
import { itemLeft, rowDistance } from './timelineLayout';

interface IProps {
    item: IEventTimelineItem;
    startYear: number;
}

export const TimelineItem: FunctionComponent<IProps> = ({ item, startYear }) => (
    <div
        className="event-timeline__item"
        style={
            {
                left: `${itemLeft(item.year, item.month, startYear)}px`,
                '--event-row': item.row,
                '--event-row-distance': `${rowDistance(item.row)}px`,
            } as CSSProperties
        }
    >
        <div className="event-timeline__item-line" />
        <div className="event-timeline__item-content">{item.content}</div>
    </div>
);
